import { supabase } from './supabase';

// Files are never thrown away when a newer one is uploaded: the old one is
// copied into the file_archive table (the file itself stays in storage) and
// shows up under "Previous versions" next to the document it belonged to.
//
// A "slot" names the one place a document lives, e.g. 'classic_id',
// 'immobilization', 'insurance:<record id>', 'documents:<record id>'.

// Call this AFTER the new file has been saved onto its record. It never throws:
// a problem archiving must not stop the user's save.
export const archiveReplacedFile = async ({ vehicleId, slot, oldUrl, oldPath = null, newUrl, label = null }) => {
  if (!vehicleId || !slot || !oldUrl) return;
  if (oldUrl === newUrl) return;
  try {
    const { error } = await supabase.from('file_archive').insert({
      vehicle_id: vehicleId,
      slot,
      url: oldUrl,
      file_path: oldPath || null,
      label,
    });
    if (error) console.warn('Could not archive the previous file:', error.message);
  } catch (err) {
    console.warn('Could not archive the previous file:', err);
  }
};
